// Generated by scripts/update-seeq-icons.js from src/svg/seeq/mag-glass-empty.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcMagGlassEmpty = {
  prefix: 'fak',
  iconName: 'mag-glass-empty' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e949',
    'M839.7 455.7c0-245.8-215-445.4-465.9-414.7-194.6 20.5-348.2 174.1-368.7 368.6-30.7 250.9 169 465.9 414.7 465.9 92.2 0 174.1-30.7 245.8-81.9l225.3 179.2c25.6 20.5 61.4 15.4 87-10.2l35.9-46.1c20.5-25.6 15.4-61.4-10.3-87.1l-215-174c30.7-56.3 51.2-122.9 51.2-199.7zM419.8 696.3c-133.1 0-240.6-107.5-240.6-240.6s107.5-240.6 240.6-240.7 240.6 107.5 240.7 240.7-107.5 240.6-240.7 240.6z',
  ],
} satisfies IconDefinition;
